import {defineMessages} from 'react-intl';

export const BrandDriverMessages = defineMessages({
  audience: {
    id: 'BrandDriver.Audience.Msg',
    defaultMessage: 'Over 100 million fans buying 1.3 tickets per second on StubHub'
  },
  secure: {
    id: 'BrandDriver.Security.Msg',
    defaultMessage: "We'll help get your tickets to buyers wherever you are"
  },
  payments: {
    id: 'BrandDriver.GetPaid.Msg',
    defaultMessage: 'Receive payment from StubHub directly'
  }
});

export const BrandDriverConfigs = {
  brandDrivers: [
    {
      name: 'audience',
      svgComponent: 'AudienceSVG',
      styles: {height: '50px'}
    },
    {
      name: 'secure',
      svgComponent: 'SecuritySVG',
      styles: {height: '50px'}
    },
    {
      name: 'payments',
      svgComponent: 'PaymentsSVG',
      styles: {height: '50px'}
    }
  ]
};

export default BrandDriverMessages;
